import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../lib/I18n';
import connectToStores from '../../helpers/connectToStores';
import NotificationStore from '../../stores/NotificationStore';
import NotificationActions from '../../actions/NotificationActions';

import PureRenderComponent from '../PureRenderComponent';


function _getStateFromStores () {
    return {
        notification: NotificationStore.getActive()
    };
}


@connectToStores([ NotificationStore ], _getStateFromStores)
class Notifications extends PureRenderComponent {

    static propTypes = {
        notification: PropTypes.string
    };

    static defaultProps = {
        notification: null
    };

    render () {
        const { notification } = this.props;
        if (notification) {
            return (
                <div className="notification text-weight--normal text-center" onClick={ NotificationActions.hideNotification }>
                    { t(notification) }
                </div>
            );
        }
        return null;
    }

}


export default Notifications;



// WEBPACK FOOTER //
// ./src/components/general/Notifications.js